// Action Log (user activity) Permissions
//
// The log is written by the backend request pipeline and rows are immutable, so
// viewing is the only capability there is — there is no create/edit/delete
// sibling to add here.
export const ACTION_LOGS_INDEX = 1496;
